<template>
  <div class='referee' v-if="list.length > 0">
    <div class="title">比赛裁判</div>
    <div v-for="item in list" :key="item.refereeId" class="item">
      <div class="role">{{ item.role }}</div>
      <div class="name">{{ item.name.join() }}</div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      gameId: '',
      list: []
    };
  },
  props: {
    referee: {
      default: () => []
    }
  },
  watch: {
    referee: {
      handler(referee) {
        const list = []
        referee.map(item => {
          const obj = { name: [], role: '' }
          const index = list.findIndex(ref => ref.role === item.role)
          if (index > -1) {
            list[index].name.push(item.name)
          } else {
            obj.role = item.role
            obj.name.push(item.name)
            list.push(obj)
          }
        })
        this.list = list
      }
    }
  }
};
</script>

<style scoped lang="scss">
.referee {
  margin-top: 18px;
  padding: 12px;
  background: #fff;

  .title {
    border-bottom: 1px solid rgb(244, 244, 244);
    padding-bottom: 8px;
  }

  .item {
    display: flex;
    padding: 12px 0;
    font-size: 14px;
    border-bottom: 1px solid rgb(244, 244, 244);

    .role {
      width: 80px;
      color: #999;
    }

    .name {
      margin-left: 8px;
    }
  }
}
</style>
